import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '@app/core';
import { SharedModule } from '@app/shared';
import { OauthModule } from './core/authentication/oauth/oauth.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { BaseAPIService } from '@app/Services/api.base.service';
import { UtilService } from '@app/Services/util.service';
import { MapModule } from '@app/map/map.module';
import { UsersModule } from '@app/users/users.module';
import { AlarmsModule } from '@app/alarms/alarms.module';
import { RulesModule } from './rules/rules.module'
import { TelemetryModule } from '@app/telemetry/telemetry.module';
import { TermsModule } from './terms/terms.module';
import { FiledownloadService } from './Services/filedownload.service';
import { ReportsModule } from './reports/reports.module';
import { DeviceModule } from './device/device.module';
import { ExportModule } from './export/export.module';
import { UploadDriversModule } from './upload-drivers/upload-drivers.module';
import { BroadcastMessageModule } from './broadcast-message/broadcast-message.module';
import { DatePipe } from '@angular/common';
import { ApiPrefixInterceptor } from './core/http/api-prefix.interceptor';
import { ErrorHandlerInterceptor } from './core/http/error-handler.interceptor';
import { DeviceGroupsModule } from './device-groups/device-groups.module';
import { StatisticsModule } from './statistics/statistics.module';
import { HaccpReportsModule } from '@app/haccp-reports/haccp-reports.module'
import { OemModule } from './oem/oem.module';
import { DeviceMetadataModule } from './device-metadata/device-metadata.module';
import { ShellComponent } from './core/shell/shell.component';
import { FooterComponent } from './core/shell/footer/footer.component';
import { HeaderComponent } from './core/shell/header/header.component';
import { SpSidenavComponent } from './sideNav/sp-sidenav.component';


@NgModule({
  exports: [],
  declarations: [
    AppComponent,
    HeaderComponent,
    SpSidenavComponent,
    FooterComponent,
    ShellComponent,
  ],
  bootstrap: [AppComponent], imports: [BrowserModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
    }),
    FormsModule,
    TranslateModule.forRoot(),
    NgbModule,
    CoreModule,
    SharedModule,
    OauthModule,
    AppRoutingModule,
    DashboardModule,
    MapModule,
    UsersModule,
    AlarmsModule,
    RulesModule,
    TelemetryModule,
    TermsModule,
    ReportsModule,
    DeviceModule,
    ExportModule,
    UploadDriversModule,
    BroadcastMessageModule,
    DeviceGroupsModule,
    StatisticsModule,
    HaccpReportsModule,
    OemModule,
    DeviceMetadataModule], providers: [BaseAPIService, UtilService, FiledownloadService, DatePipe,
      { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: ApiPrefixInterceptor, multi: true }, provideHttpClient(withInterceptorsFromDi())]
})
export class AppModule { }
